export default {
    user_id: null,
    user_name: null,
    company_id: null,
    company_name: null,
    primary_color: null,
    is_power_user: false,
    time_zone: '',
    permissions: [],
    notifications_preferences: undefined,
    tier: {
        pois: null,
        brands: 30,
        categories: 5
    },
    tierStatus: {
        pois: 0,
        brands: 0,
        categories: 0
    },
    tier_loading: true,
}